import { Component, OnInit } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-small-footer',
  templateUrl: './small-footer.component.html',
  styleUrls: ['./small-footer.component.scss']
})
export class SmallFooterComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }
}
